import React, { createContext, useMemo, useRef } from 'react';

/**
 *
 *  @internal
 * Context which maintains the current level of dropdown menu if it is nested
 * Default is 0
 *
 */
export var NestedLevelContext = /*#__PURE__*/createContext(0);

/**
 *
 * @internal
 * Context which maintains the maximun level of dropdown menu if it is nested
 * Default is 0
 *
 */
export var TrackMaxLevelContext = /*#__PURE__*/createContext({
  maxLevelRef: {
    current: 0
  },
  setMaxLevel: function setMaxLevel() {}
});

/**
 *
 *  @internal
 * Context provider which maintains the maximun level of dropdown menu if it is nested
 *
 */
export var TrackLevelProvider = function TrackLevelProvider(_ref) {
  var children = _ref.children;
  var maxLevelRef = useRef(0);
  var value = useMemo(function () {
    return {
      maxLevelRef: maxLevelRef,
      setMaxLevel: function setMaxLevel(level) {
        var isMin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        maxLevelRef.current = isMin ? Math.min(maxLevelRef.current, level) : level;
      }
    };
  }, [maxLevelRef]);
  return /*#__PURE__*/React.createElement(TrackMaxLevelContext.Provider, {
    value: value
  }, children);
};